export default "__VITE_ASSET__oDfbHgRu__"